import styles from "../../../styles/components/StatusFeedbackModal.module.css";
import { useOverlayClose } from "../../../hooks/useOverlayClose";

const StatusFeedbackModal = ({
  isOpen = false,
  status = "loading",
  title = "",
  message = "",
  onClose,
}) => {
  const isLoading = status === "loading";
  const isSuccess = status === "success";
  const isError = status === "error";
  const overlayCloseProps = useOverlayClose(!isLoading ? onClose : undefined);

  if (!isOpen) return null;

  return (
    <div className={styles.overlay} {...overlayCloseProps}>
      <div
        className={styles.modal}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.content}>
          {isLoading ? (
            <div className={styles.loading}>
              <div className={styles.loadingRing} />
            </div>
          ) : null}

          {isSuccess ? (
            <div className={`${styles.iconCircle} ${styles.successCircle}`}>
              <div className={styles.iconSymbol}>✓</div>
            </div>
          ) : null}

          {isError ? (
            <div className={`${styles.iconCircle} ${styles.errorCircle}`}>
              <div className={styles.iconSymbol}>✕</div>
            </div>
          ) : null}

          <div className={styles.textBlock}>
            <div className={styles.title}>{title}</div>
            <div className={styles.message}>{message}</div>
          </div>

          {!isLoading && onClose ? (
            <button
              type="button"
              className={styles.closeButton}
              onClick={onClose}
            >
              Cerrar
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default StatusFeedbackModal;
